import { lazy } from "react";
import { SERVICES } from "pages/routes/route.constant";
const service = lazy(() => import("pages/Services"));

export default {
  path: SERVICES,
  element: service,
};
